export namespace ResetPasswordRecoveryPasswordCompleteNamespace {
  export interface IN {
    password: string;
    token: string;
    //recaptchaToken: string;
  }

  export class OUT {
    // requestKey: string = '';
    // init(input: ResetPasswordRecoveryPasswordCompleteApiNamespace.OUT) {
    //   // this.requestKey = input.recoverPasswordKey;
    //   return this;
    // }
  }
}
